import { jsxs as M, jsx as c } from "react/jsx-runtime";
import p from "dayjs";
import { useState as g, useEffect as h } from "react";
import { IconNames as $ } from "@blueprintjs/icons";
import { conditionalString as l } from "@strata/helper-functions";
import { Icon as v } from "@strata/react-status-icons";
import { StatusIndicator as i } from "@strata/react-status-indicators";
import E from "classnames";
import "./main.scss";
const I = ({
  timeInSeconds: t,
  cautionTimeThresholdSeconds: r,
  warningTimeThresholdSeconds: o,
  hideStatus: s
}) => s ? i.Status.DEFAULT : r != null && t <= r ? i.Status.CAUTION : o != null && t <= o ? i.Status.WARNING : i.Status.DEFAULT, S = (t) => {
  if (t <= 0)
    return "ENDED";
  const r = l(Math.floor(t / 86400) > 0, `${Math.floor(t / 86400)}d`), o = l(Math.floor(t / 3600) > 0, `${Math.floor(t / 3600)}h`), s = l(
    Math.floor(t % 3600 / 60) !== 0,
    `${Math.floor(t % 3600 / 60)}m `
  ), a = l(s !== "" && o !== "", " "), n = l(t < 120, `${t % 60}s`);
  return r === "" ? `${o}${a}${s}${n}` : r;
}, N = ({
  timeInSeconds: t,
  cautionTimeThresholdSeconds: r = void 0,
  warningTimeThresholdSeconds: o = void 0,
  showTimePastEnded: s = !1,
  tooltipText: a = void 0,
  hideStatus: n = void 0,
  paused: f = !1
}) => {
  const u = S(
    s ? Math.abs(t) : t
  );
  let e;
  return f ? e = /* @__PURE__ */ M("span", { className: "sds_time-indicator__message--paused", children: [
    /* @__PURE__ */ c(v, { icon: $.PAUSE }),
    u
  ] }) : e = u, /* @__PURE__ */ c(
    i,
    {
      status: I({
        timeInSeconds: t,
        cautionTimeThresholdSeconds: r,
        warningTimeThresholdSeconds: o,
        hideStatus: n
      }),
      message: e,
      tooltipText: a,
      className: E({
        "sds_time-indicator__container--paused": f
      })
    }
  );
}, d = (t) => p(t).diff(void 0, "seconds"), F = ({
  endTime: t,
  cautionTimeThresholdSeconds: r = 300,
  warningTimeThresholdSeconds: o,
  showTimePastEnded: s = !1,
  tooltipText: a,
  hideStatus: n
}) => {
  const [f, u] = g(d(t));
  return h(() => {
    const e = setInterval(() => {
      u(d(t));
    }, 1e3);
    return () => {
      clearInterval(e);
    };
  }, [t]), /* @__PURE__ */ c(
    N,
    {
      timeInSeconds: f,
      cautionTimeThresholdSeconds: r,
      warningTimeThresholdSeconds: o,
      showTimePastEnded: s,
      tooltipText: a,
      hideStatus: n
    }
  );
}, T = ({ timeElapsedInSeconds: t }) => /* @__PURE__ */ c("span", { children: ((o) => o == null || o < 0 ? "" : Math.floor(o / 86400) > 0 ? `${Math.floor(o / 86400)}d ago` : Math.floor(o / 3600) > 0 ? `${Math.floor(o / 3600)}h ago` : Math.floor(o % 3600 / 60) ? `${Math.floor(o % 3600 / 60)}m ago` : `${o}s ago`)(t) }), m = (t) => p().diff(t, "seconds"), L = ({ startTime: t }) => {
  const [r, o] = g(m(t));
  return h(() => {
    const s = setInterval(() => {
      o(m(t));
    }, 1e3);
    return () => {
      clearInterval(s);
    };
  }, [t]), /* @__PURE__ */ c(T, { timeElapsedInSeconds: r });
};
export {
  L as CountUpTimer,
  F as CountdownTimer,
  T as ElapsedTimeIndicator,
  N as TimeIndicator
};
//# sourceMappingURL=index.js.map
